/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, lazy, Suspense } from 'react'

const RoutewareWizard = lazy(() => import('./routeware-wizard'))

const RoutewareWizardComponent = (props) => {

    const component = props?.component

    return (
        <Fragment>
            <div>
                <Suspense fallback={<div>Loading...</div>}>
                    <RoutewareWizard component={component} />
                </Suspense>
            </div>
        </Fragment>
    )
}

export { RoutewareWizardComponent }

